// extracted by mini-css-extract-plugin
export default {"tableRow":"DamagedLostPalletsTableMainRow_tableRow__hPZ5t","tableRowWithoutBottomBorder":"DamagedLostPalletsTableMainRow_tableRowWithoutBottomBorder__h-vEH"};